// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"31c0722e","239":"54c98e07","732":"5310bee4"}[chunkId] + ".chunk.js";
};